import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import CommonForm from "./CommonForm";
import { addCommonThunk, reorderCommonThunk } from "../../../actions/common";
import { toast } from "react-toastify";
import { createSwapy } from "swapy";
import "./common_form_swap.css";

function Commons() {
  const tree_detail = useSelector(state => state.treeDetail);
  const primary_common = useSelector(state => state.treeDetail.primary_common);
  const other_common = useSelector(state => state.treeDetail.other_common);
  const swapy = useRef(null);
  const container = useRef(null);
  const [newOrder, setNewOrder] = useState(false);
  const dispatch = useDispatch();

  const [slotItemsMap, setSlotItemsMap] = useState(
    [primary_common, ...other_common].map((item, idx) => ({ slotId: idx, itemId: item.common_id }))
  );

  const slottedItems = useMemo(
    () =>
      slotItemsMap.map(({ slotId, itemId }) => ({
        slotId,
        itemId,
        item: [primary_common, ...other_common].find(item => item.common_id == itemId),
      })),
    [slotItemsMap]
  );

  useEffect(() => {
	setSlotItemsMap(
		[primary_common, ...other_common].map((item, idx) => ({ slotId: idx, itemId: item.common_id }))
	);
  }, [primary_common, other_common]);

  useEffect(() => {
    // If container element is loaded
    if (container.current) {
      swapy.current = createSwapy(container.current, {
        manualSwap: true,
        swapMode: "drop",
        autoScrollOnDrag: true,
        animation: "none",
      });
    }

    // Your event listeners
    swapy.current.onSwap(event => {
      setNewOrder(event.data.object);
      if (swapy.current) {
        swapy.current.setData({ array: event.data.array });
        setSlotItemsMap(event.data.array);
      }
    });

    return () => {
      // Destroy the swapy instance on component destroy
      if (swapy.current) {
        swapy.current.destroy();
      }
    };
  }, []);

  function addCommon() {
    dispatch(addCommonThunk(tree_detail.tree_id)).then(res => {
      if (res.status === 201) {
        toast.success("Added Common");
      } else {
        toast.error("Couldn't Add Common");
      }
    });
  }

  function reorder() {
    dispatch(reorderCommonThunk(tree_detail.tree_id, newOrder)).then(res => {
      if (res.status === 200) {
        toast.success("New Common Order Saved");
        setNewOrder(false);
      } else {
        toast.error("Could Not Save New Common Order");
      }
    });
  }

  function render_slots() {
    return (
      <div ref={container} className="swapy-container">
        <hr style={{ margin: "0.5rem 0" }} />
        <ol style={{ padding: "0" }}>
          {slottedItems.map(item => (
            <div data-swapy-slot={item.slotId} className="swapy-section">
              <div data-swapy-item={item.itemId} className="swapy-item">
                {item.item && (
                  <CommonForm key={item.itemId} common={item.item} />
                )}
              </div>
            </div>
          ))}
        </ol>
      </div>
    );
  }

  return (
    <>
      <Form.Label style={{ margin: "1rem 0 0 0" }}>Common Names</Form.Label>
      {render_slots()}
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <span onClick={addCommon} className="form-button-primary">
          + Add New Common
        </span>
        {newOrder && (
          <span onClick={reorder} className="form-button-primary">
            Save Order
          </span>
        )}
      </div>
    </>
  );
}

export default Commons;
